/** Minimal shape of the error object Nuxt hands to `error.vue`. */
export type MaintenanceErrorCandidate = {
    statusCode?: number
    statusMessage?: string
    message?: string
}

/**
 * Whether an error from `error.vue` is Shopware's maintenance mode.
 *
 * `@shopware/nuxt-module` raises it as `showError({ statusCode: 503, statusMessage:
 * 'MAINTENANCE_MODE' })` whenever a store-api response carries
 * `FRAMEWORK__API_SALES_CHANNEL_MAINTENANCE_MODE`. That `statusMessage` survives on the
 * client, but h3 normalizes it to the HTTP reason phrase ("Service Unavailable") during
 * SSR — hence the second condition, which matches Shopware's own message text instead.
 */
export function isMaintenanceError(error: MaintenanceErrorCandidate): boolean {
    return (error.statusCode ?? 500) === 503 && (
        error.statusMessage === 'MAINTENANCE_MODE'
        || /maintenance mode/i.test(error.message ?? '')
    )
}
